// extracted by mini-css-extract-plugin
export default {"ModalClass":"_ModalClass--YlPhu","ModalBodyClass":"_ModalBodyClass--nHUs4","FoundAlternativeTitle":"_FoundAlternativeTitle--fdY8s","OptionsWrapper":"_OptionsWrapper--XtWGl"};